import { render, staticRenderFns } from "./forwards2.vue?vue&type=template&id=50f1c3ba&"
import script from "./forwards2.vue?vue&type=script&lang=js&"
export * from "./forwards2.vue?vue&type=script&lang=js&"
import style0 from "./forwards2.vue?vue&type=style&index=0&id=50f1c3ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports